export const someInitHandler = async (__, thunkApi) => {
    try {
      const { default:defaultAxios } = thunkApi.extra.apiService;
      return {};
    } catch (err) {
      return Promise.reject(err);
    }
  };